export default __webpack_public_path__ + "static/HeroSectionRight_it-ca584b5000760e7dd02464ee39c68e2d.png";